import React, { useEffect, useState } from "react";
import { Script } from "gatsby";
import { Spinner } from "../Icons";
import Wysiwyg from "../Wysiwyg";

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create(args: {
          target: string;
          region: string;
          portalId: string;
          formId?: string;
        }): any;
      };
    };
  }
}

const init = (formID?: string, onReady?: () => void) => {
  if (!window.hbspt) {
    return;
  }

  const form = window.hbspt.forms.create({
    // TODO: can also use useId() to generate a unique target id
    target: "#h-form",
    region: "na1",
    portalId: "19526340",
    formId: formID,
  });

  if (onReady) {
    form.onReady(onReady);
  }
};

interface Props {
  formID?: string;
  fallbackContent?: string;
  className?: string;
}

export const Form = ({ formID, fallbackContent, className }: Props) => {
  fallbackContent = fallbackContent ?? "Het laden van het formulier is mislukt";

  const [loaded, setLoaded] = useState(false);
  const [isTimedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timeoutTimer = setTimeout(() => {
      setTimedOut(true);
    }, 2000);

    return () => clearTimeout(timeoutTimer);
  });

  return (
    <>
      <Script
        src="https://js.hsforms.net/forms/v2.js"
        strategy="post-hydrate"
        onLoad={() =>
          init(formID, () => {
            setLoaded(true);
          })
        }
        onError={(err) => {
          setTimedOut(true);
          console.error(err);
        }}
      />
      {!loaded && (
        <div className="flex h-128 items-center justify-center">
          {!isTimedOut && <Spinner />}
          {isTimedOut && <Wysiwyg>{fallbackContent}</Wysiwyg>}
        </div>
      )}
      <div id="h-form" className={className} />
    </>
  );
};
